module.exports = __webpack_public_path__ + "img/clue01_bg.a6b1e1b0.png";